import * as actions from "actions";
import { isFriday } from "date-fns/esm";
import { LOCATION_CHANGE } from "react-router-redux";

import { spinnerService } from '@chevtek/react-spinners';

const defaultSingleInvoice = {
  singleInvoiceFile: "",
  singleInvoiceCompanyName: "",
  singleInvoiceCompanyNumber: "",
  singleInvoiceDueDate: "",
  singleInvoiceIssueDate: "",
  singleInvoiceAmount: "",
  singleInvoiceReferralUrl: "",
  singleInvoiceTotalPrice: "",
  singleInvoiceRejectionReason: "",
  singleInvoiceStatus: "",
  singleInvoiceAutoFillDone: false,
  singleInvoiceNumber: ""
};

const ini = {
  domain: {},
  domainInfoLoaded: false,
  //
  retrievalDone: false,
  sessionId: "",
  //tab0
  fullName: "",
  email: "",
  phoneNumber: "",
  acceptedTerms: false,
  //tab1
  companyName: "",
  companyNumber: "",
  companyAddress: "",
  companyDescription: null,
  //tab1 - turnover
  companyPredictedTurnover: "",
  //single invoice
  ...defaultSingleInvoice,
  //tab1 - drawn down
  requiresInvoiceFinance: false,
  //tab2
  tradesOutsideOfTheUk: false,
  //tab3
  countries: [],
  //tab4
  years: [],
  yearsNotSure: false,
  //tab5
  customers: [],
  //company search
  companySearchFromTab: "",
  companySearchResults: [],
  companySearchQ: "",
  companySearchIsOpen: false,
  nextStepBtnLoading: false
  //
};
export default function appReducer(state = ini, action) {
  if (process.env.NODE_ENV !== "production") {
    console.log(action);
  }
  switch (action.type) {
    case LOCATION_CHANGE:
    const urlParams = new URLSearchParams(action.payload.search);
      if (urlParams.get("activeTab") === "tab1") {
        return {
          ...state,
          tab1ShowExtraFields: false,
          tab1AutoFillDone: false
        }
      }
      return { ...state };
    case actions.SINGLE_INVOICE_PRICE_RESET:
      return {
        ...state,
        ...defaultSingleInvoice
      };
    case actions.SINGLE_INVOICE_PRICE_OK:
      return {
        ...state,
        ...action.payload
      };
    case actions.TAB_6_REQUEST_PRICE_OK:
      return {
        ...state,
        ...action.newP
      };
    case actions.TAB_5B_UPDATE_INVOICE:
      return {
        ...state,
        customers: state.customers.map((customer, i) => {
          if (i === action.index) {
            return {
              ...customer,
              [action.name]: action.value
            };
          }
          return customer;
        })
      };
    case actions.TAB_5A_DELETE_CUSTOMER:
      return {
        ...state,
        customers: state.customers.filter((_, i) => i !== action.i)
      };
    case actions.TAB_5A_ADD_CUSTOMER:
      if (
        state.customers.filter(customer => customer.companyName === action.name)
          .length > 0
      ) {
        return state;
      }

      return {
        ...state,
        customers: [
          ...state.customers,
          {
            autoFilled: false,
            companyName: action.name,
            companyAddress: "",
            companyNumber: "",
            highestAmountOwing: ""
          }
        ]
      };
    case actions.TAB_5A_ADD_CUSTOMER_AUTOFILL:
      let name =
        typeof action.company.Address === "string"
          ? action.company.Name
          : action.company.Title;

      if (
        state.customers.filter(customer => customer.companyName === name)
          .length > 0
      ) {
        return state;
      }
      return {
        ...state,
        customers: [
          ...state.customers,
          {
            autoFilled: true,
            companyName: name,
            companyAddress: addressFormatter(action.company.Address),
            companyNumber: action.company.CompanyNumber,
            highestAmountOwing: ""
          }
        ]
      };
    case actions.TAB_4B_UPDATE_INVOICE:
      return {
        ...state,
        years: state.years.map(year => {
          if (year.value === action.yearValue) {
            return { ...year, [action.name]: action.value };
          }
          return year;
        })
      };
    case actions.TAB_4B_RESET_HELP_BLOCK:
      return { ...state, helpBlockTab4BIsOpen: false };
    case actions.TAB_4B_TRIGGER_HELP_BLOCK:
      return { ...state, helpBlockTab4BIsOpen: true };
    case actions.TAB_4A_TOGGLE_YEAR:
      //override for not_sure
      if (action.name === "not_sure") {
        return { ...state, years: [], yearsNotSure: !state.yearsNotSure };
      }
      //normal year behaviour
      if (action.checked) {
        return {
          ...state,
          yearsNotSure: false,
          years: [
            ...state.years,
            {
              value: action.name,
              label: action.label,
              totalSales: "",
              totalBadDebts: "",
              largestBadDebt: ""
            }
          ].sort(function(a, b) {
            return b["value"] - a["value"];
          })
        };
      } else {
        return {
          ...state,
          yearsNotSure: false,
          years: state.years.filter(year => year.value !== action.name)
        };
      }
    case actions.TAB_3B_UPDATE_INVOICE:
      return {
        ...state,
        countries: state.countries.map(country => {
          if (country.value === action.countryValue) {
            return { ...country, [action.name]: action.value };
          }
          return country;
        })
      };
    case actions.TAB_3B_RESET_HELP_BLOCK:
      return { ...state, helpBlockTab3BIsOpen: false };
    case actions.TAB_3B_TRIGGER_HELP_BLOCK:
      return { ...state, helpBlockTab3BIsOpen: true };
    case actions.TAB_3A_UPDATE_SELECTED_COUNTRIES:
      //copy current countries array
      let oldCountries = state.countries.slice();
      let newCountries = action.countries;
      //loops for adding new countries to state array
      newCountries.forEach(newCountry => {
        let found = false;
        oldCountries.forEach(oldCountry => {
          if (oldCountry.value === newCountry.value) {
            found = true;
          }
        });
        if (!found) {
          oldCountries.push({
            ...newCountry,
            annualSales: "",
            approxCustomers: "",
            creditTerms: ""
          });
        }
      });
      //loops for deleting countries from state array
      oldCountries.forEach((oldCountry, i) => {
        let found = false;
        newCountries.forEach(newCountry => {
          if (oldCountry.value === newCountry.value) {
            found = true;
          }
        });
        if (!found) {
          oldCountries.splice(i, 1);
        }
      });
      return {
        ...state,
        countries: oldCountries
      };
    case actions.MOVE_TAB:
      if (action.fromTab === "tab2") {
        return {
          ...state,
          tradesOutsideOfTheUk: action.tab2Answer
        };
      }
      return state;
    case actions.TAB_1_AUTOFILL_SELECTED:
      return {
        ...state,
        companyName:
          typeof action.company.Address === "string"
            ? action.company.Name
            : action.company.Title,
        companyNumber: action.company.CompanyNumber,
        companyAddress: addressFormatter(action.company.Address),
        companyDescription: action.activities,
        tab1ShowExtraFields: true,
        tab1AutoFillDone: true
      };
    case actions.SINGLE_INVOICE_AUTOFILL:
      return {
        ...state,
        singleInvoiceCompanyName:
          typeof action.company.Address === "string"
            ? action.company.Name
            : action.company.Title,
        singleInvoiceCompanyNumber: action.company.CompanyNumber,
        singleInvoiceCompanyAddress: addressFormatter(action.company.Address),
        singleInvoiceAutoFillDone: true,
        singleInvoiceShowExtraFields: true
      };
    case actions.SINGLE_INVOICE_AUTOFILL_RESET:
        return {
          ...state,
          singleInvoiceAutoFillDone: false
        }
    case actions.COMPANY_SEARCH_HIDE:
      return {
        ...state,
        companySearchIsOpen: false,
        companySearchQ: "",

        ...(action.fromTab === "tab1" ||
        action.fromTab === "singleInvoiceCompany"
          ? action.isTryAgain
            ? {
                [action.fromTab + "AutoFillDone"]: false,
                [action.fromTab + "ShowExtraFields"]: false,
                [action.fromTab + "TryAgain"]: true
              }
            : {
                [action.fromTab + "AutoFillDone"]: true,
                [action.fromTab + "ShowExtraFields"]: true,
                [action.fromTab + "TryAgain"]: false
              }
          : {})
        //   tab1ShowExtraFields: action.fromTab === "tab1" ? true : state.tab1ShowExtraFields,
        // tab1TryAgain: action.fromTab === "tab1" && action.isTryAgain ? true : state.tab1TryAgain,

        //tab1AutoFillDone: action.fromTab === "tab1" ? true : state.tab1AutoFillDone,
        //  singleInvoiceShowExtraFields: action.fromTab === "singleInvoice" ? true : state.singleInvoiceShowExtraFields,
        //singleInvoiceAutoFillDone: action.fromTab === "singleInvoice" ? true : state.singleInvoiceAutoFillDone
      };
    case actions.COMPANY_SEARCH_RESET_RESULTS:
      return { ...state, companySearchResults: [] };
    case actions.COMPANY_SEARCH_LOAD_OK:
      return {
        ...state,
        companySearchFromTab: action.fromTab,
        companySearchQ: action.q,
        companySearchSecondaryId: action.secondaryId,
        companySearchResults: action.results,
        companySearchIsOpen: true
      };
    case actions.UPDATE_INPUT:
      return { ...state, [action.name]: action.value };
    case actions.GET_SESSION_OK:
      return {
        ...state,
        retrievalDone: true,
        sessionId: action.sessionId,
        ...action.data
      };
    case actions.CREATE_SESSION_OK:
      return {
        ...state,
        sessionId: action.sessionId,
        refNumber: action.refNumber,
        retrievalDone: true
      };
    case actions.CREATE_SESSION:
      const domain = { ...state.domain };
      if (action.singleInvoiceEnabled) {
        domain.SingleInvoiceEnabled = action.singleInvoiceEnabled === "true" ? true : false;
      }
      if (action.singleInvoiceThreshold) {
        domain.SingleInvoiceThreshold = action.singleInvoiceThreshold
      }
      return {
        ...state,
        forceSingleInvoice: action.forceSingleInvoice === "true" ? true : false,
        domain,
      };
    case actions.GET_SUBDOMAIN_INFO_OK:
      return {
        ...state,
        domainInfoLoaded: true,
        domain: action.data
      };
    case actions.NEXT_STEP_BTN_START_LOADING:
      spinnerService.show('buttonSpinner');
      return {
        ...state,
        nextStepBtnLoading: true
      }
    case actions.NEXT_STEP_BTN_FINISH_LOADING:
      spinnerService.hide('buttonSpinner');
      return {
        ...state,
        nextStepBtnLoading: false
      }
    default:
      return state;
  }
}

function addressFormatter(a) {
  if (typeof a === "string") {
    return a;
  }

  let o = "";
  if (a.Premises !== null) {
    o = o + a.Premises;
    if (a.AddressLine1 !== null) {
      o = o + " ";
    }
  }
  if (a.AddressLine1 !== null) {
    o = o + a.AddressLine1;
  }
  if (a.Locality !== null) {
    o = o + ",\n" + a.Locality;
  }
  if (a.Country !== null) {
    o = o + ",\n" + a.Country;
  }
  if (a.PostalCode !== null) {
    o = o + ",\n" + a.PostalCode;
  }
  return o;
}
